export default __webpack_public_path__ + "static/identity-mock-e8df96fdbc6dd698f6e09be88770c6f7.png";